import React, { FC, FormEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormFields } from 'hooks/useFormFields'
import { useRequestPassword } from 'services/auth'
import { Link } from 'react-router-dom'
import { Card } from 'components/Card'
import { Stack } from 'components/Stack'
import { Heading } from 'components/Heading'
import { Text } from 'components/Text'
import { Flex } from 'components/Flex'
import { TextInput } from 'components/TextInput'
import { Button } from 'components/Button'
import { Alert } from 'components/Alert'
import { Logo } from 'features/shared/Logo'
import styles from './RequestPassword.module.scss'

export const RequestPassword: FC = () => {
  const { t } = useTranslation()
  const [requestPassword, { status }] = useRequestPassword()
  const [form, onFieldChange] = useFormFields({
    email: '',
  })

  const onFormSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    requestPassword(form)
  }

  return (
    <Flex justify="center" align="center" className={styles.recoverPassword}>
      <Card>
        <Stack space="large">
          <Stack space="small">
            <Heading size="secondary">{t('forgot_password.request.title')}</Heading>
            <Text>{t('forgot_password.request.subtitle')}</Text>
          </Stack>

          <form onSubmit={onFormSubmit}>
            <Stack space="medium">
              <TextInput
                name="email"
                type="email"
                value={form.email}
                onChange={onFieldChange}
                label={t('forgot_password.request.form.email')}
                required
              />

              <Button type="submit" loading={status === 'loading'}>
                {t('forgot_password.request.form.cta')}
              </Button>

              {status === 'error' && (
                <Alert tone="critical" full>
                  {t('forgot_password.request.error')}
                </Alert>
              )}

              {status === 'success' && (
                <Alert tone="positive" full>
                  {t('forgot_password.request.success')}
                </Alert>
              )}
            </Stack>
          </form>

          <Link to="/login">{t('forgot_password.request.login_cta')}</Link>

          <Logo />
        </Stack>
      </Card>
    </Flex>
  )
}

RequestPassword.displayName = 'RecoverPassword'
